export function getSite() {
  const site: string = process.env.OCELOT_SITE || '';
  if (!site) throw new Error('Missing env: OCELOT_SITE');
  return site;
}
